import { useTranslation } from 'react-i18next'
import { useApproveNotification, useDeclineNotification } from '../api/notificationApi'
import { useNotificationsUi } from './provider'

export function useNotificationsData() {
  const { t, i18n } = useTranslation('admin')
  const lang = i18n.language
  const { notifications, moderationIssues } = useNotificationsUi()
  const { mutate: approve, isPending: approving, variables: approvingId } = useApproveNotification()
  const { mutate: decline, isPending: declining, variables: decliningId } = useDeclineNotification()

  /** Заявка, по которой сейчас идёт запрос: обе её кнопки недоступны. */
  const isBusy = (id: number) =>
    (approving && approvingId === id) || (declining && decliningId === id)

  const fieldLabels: Record<string, string> = {
    city: t('notification.field.city'),
    email: t('email'),
    grade: t('notification.field.grade'),
    school: t('notification.field.school'),
    country: t('notification.field.country'),
    full_name_en: t('notification.field.full_name_en'),
    full_name_ru: t('notification.field.full_name_ru'),
    phone: t('notification.field.phone'),
    birth_date: t('notification.field.birth_date'),
    olympiad: t('notification.field.olympiad'),
    amount: t('notification.field.amount'),
    representative_id: t('notification.field.representative_id'),
  }

  return { notifications, approve, decline, isBusy, moderationIssues, fieldLabels, lang }
}
